import { render } from "./AlterWallHistoryComponent.vue?vue&type=template&id=270a07d2&scoped=true"
import script from "./AlterWallHistoryComponent.vue?vue&type=script&lang=js"
export * from "./AlterWallHistoryComponent.vue?vue&type=script&lang=js"

import "./AlterWallHistoryComponent.vue?vue&type=style&index=0&id=270a07d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270a07d2"]])

export default __exports__